import React from "react";
import SaveIcon from "@material-ui/icons/SaveAlt";
import DoneAll from "@material-ui/icons/DoneAll";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import Clear from "@material-ui/icons/Clear";
import {
  IndexViewComponent,
  PopupMessage,
  SecuredListButton
} from "lego-gui-lib/lib";
import { GetApp } from "@material-ui/icons";
import { mainStore } from "../../../core/mainStore";
import { t } from "../../../core/i18n/i18n";
import { inject } from "mobx-react";
import { capitalize } from "@material-ui/core/utils";

export const toolbarButtonsWithSwitch = (switchPropertyName: string) => (
  indexProps: IndexViewComponent<any, any>
) => (close: () => void) => {
  const arr = [];
  const commons = mainStore.commons;
  const propertyName = switchPropertyName;

  const remove = (e: any) => {
    indexProps.callbackDelete(indexProps.props.dataSource.selected);
    close();
  };

  const exportSelected = () => {
    indexProps.props.dataSource.exportSelected(
      "text/csv",
      indexProps.props.dataSource.selected
    );
    close();
  };

  const exportAll = () => {
    indexProps.props.dataSource.exportAll(
      "text/csv",
      indexProps.prepareParams()
    );
    close();
  };

  const Button = inject("i18n")(
    ({ i18n: i18n, title: titleArgs, ...props }) => {
      const title = capitalize(i18n.t(...titleArgs));
      return <SecuredListButton title={title} {...props} />;
    }
  );

  const enable = () => {
    const message: PopupMessage = {
      title: t("lego:views.index.row.operationPopup", {
        operation: "lego:views.index.row.enablePlural",
        length: indexProps.props.dataSource.selected.length
      })(),
      content: t("lego:views.index.row.operationContent", {
        operation: "lego:views.index.row.enable"
      })()
    };
    commons.showDialog(message, groupEnable);
  };

  const disable = () => {
    const message: PopupMessage = {
      title: t("lego:views.index.row.operationPopup", {
        operation: "lego:views.index.row.disablePlural",
        length: indexProps.props.dataSource.selected.length
      })(),
      content: t("lego:views.index.row.operationContent", {
        operation: "lego:views.index.row.disable"
      })()
    };
    commons.showDialog(message, groupDisable);
  };

  const groupEnable = () => {
    indexProps.props.dataSource.updateRows(
      indexProps.props.dataSource.selected,
      { [propertyName]: 1 }
    );
    commons.closeDialog();
    close();
  };

  const groupDisable = () => {
    indexProps.props.dataSource.updateRows(
      indexProps.props.dataSource.selected,
      { [propertyName]: 0 }
    );
    commons.closeDialog();
    close();
  };

  arr.push(
    <Button
      title={["lego:views.index.row.exportAll", "Export All"]}
      callbackFunction={exportAll}
      key={"exportAll"}
    >
      <GetApp />
    </Button>
  );

  arr.push(
    <Button
      title={["lego:views.index.row.export", "Export"]}
      callbackFunction={exportSelected}
      key={"export"}
      disabled={indexProps.props.dataSource.selected.length === 0}
    >
      <SaveIcon />
    </Button>
  );

  arr.push(
    <Button
      title={["lego:views.index.row.delete", "Delete"]}
      callbackFunction={remove}
      key={"delete"}
      disabled={indexProps.props.dataSource.selected.length === 0}
    >
      <DeleteIcon />
    </Button>
  );

  arr.push(
    <Button
      title={["lego:views.index.row.enable", "Enable"]}
      callbackFunction={enable}
      key={"enable"}
      disabled={indexProps.props.dataSource.selected.length === 0}
    >
      <DoneAll />
    </Button>
  );

  arr.push(
    <Button
      title={["lego:views.index.row.disable", "Disable"]}
      callbackFunction={disable}
      key={"disable"}
      disabled={indexProps.props.dataSource.selected.length === 0}
    >
      <Clear />
    </Button>
  );

  return arr;
};
